/* Stooner · Carrito lateral (2/2): acciones, abrir/cerrar y eventos */
(function () {
  'use strict';
  var D = window.__scd;
  if (!D || D.ui) return;
  D.ui = true;

  var S = D.S, root = D.root, q = D.q, qa = D.qa, conf = D.conf, esc = D.esc;

  /* ---------- Recomendados ---------- */
  function bind() {
    var tr = D.track();
    if (tr && !tr.__scdBound) {
      tr.__scdBound = true;
      tr.addEventListener('scroll', D.updateArrows, { passive: true });
    }
  }

  function scrollUp(dir) {
    var tr = D.track();
    if (!tr) return;
    var card = q('.scd-up__card:not([hidden])', tr);
    var gap = parseFloat(getComputedStyle(tr).columnGap) || 8;
    var step = card ? (card.offsetWidth + gap) * (Number(conf('up-visible')) || 2) : tr.clientWidth * 0.8;
    tr.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  function closeSheets() {
    qa('.scd-up__sheet').forEach(function (s) { s.hidden = true; });
  }

  function handleUpAdd(card, btn) {
    var variants = D.parse(card.getAttribute('data-variants'));
    var avail = variants.filter(function (v) { return v.a; });
    if (!avail.length) return;
    if (avail.length === 1 || card.getAttribute('data-single') === 'true') {
      addVariant(avail[0].id, btn);
      return;
    }
    closeSheets();
    var sheet = q('.scd-up__sheet', card);
    var list = q('[data-scd-sheet-list]', card);
    if (!sheet || !list) return;
    list.innerHTML = variants.map(function (v) {
      return '<button type="button" class="scd-chip' + (v.a ? '' : ' is-out') + '" data-scd-pick data-vid="' + v.id + '"' + (v.a ? '' : ' disabled') + '>' + esc(v.t) + '</button>';
    }).join('');
    sheet.hidden = false;
  }

  /* ---------- Acciones de carrito ---------- */
  function toast(msg) {
    var t = q('[data-scd-toast]');
    if (!t || !msg) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(S.toastT);
    S.toastT = setTimeout(function () { t.hidden = true; }, 3200);
  }

  function addVariant(id, btn) {
    S.internal++;
    if (btn) btn.classList.add('is-busy');
    return D.post(conf('add-url') || '/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          toast(res.data.description || res.data.message || conf('stock-msg'));
          return null;
        }
        closeSheets();
        return D.refresh();
      })
      .catch(function () { toast(conf('stock-msg')); })
      .then(function (x) {
        S.internal--;
        if (btn) btn.classList.remove('is-busy');
        return x;
      });
  }

  function changeQty(key, qty, row) {
    S.internal++;
    if (row) row.classList.add('is-busy');
    return D.post(conf('change-url') || '/cart/change.js', { id: key, quantity: qty })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          toast(res.data.description || res.data.message || conf('stock-msg'));
          return D.refresh();
        }
        S.cart = res.data;
        D.render();
        D.syncBubble();
      })
      .catch(function () { return D.refresh(); })
      .then(function () {
        S.internal--;
        if (row) row.classList.remove('is-busy');
      });
  }

  /* ---------- Abrir / cerrar ---------- */
  function open() {
    var r = root();
    if (!r || r.classList.contains('is-open')) return;
    S.lastFocus = document.activeElement;
    S.wasOpen = true;
    r.classList.add('is-open');
    r.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('scd-lock');
    qa('[aria-controls="cart-drawer"]', document).forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    if (!S.loaded) D.refresh();
    else D.animateBar();
    bind();
    setTimeout(function () {
      D.updateArrows();
      var p = q('[data-scd-panel]');
      if (p) p.focus({ preventScroll: true });
    }, 60);
  }

  function openWhenFree() {
    var dlg = null;
    try { dlg = document.querySelector('dialog:modal'); } catch (e) { dlg = null; }
    if (dlg) {
      dlg.addEventListener('close', open, { once: true });
      setTimeout(function () { if (dlg.open) dlg.close(); }, 700);
    } else {
      open();
    }
  }

  function close() {
    var r = root();
    if (!r || !r.classList.contains('is-open')) return;
    S.wasOpen = false;
    r.classList.remove('is-open');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('scd-lock');
    closeSheets();
    qa('[aria-controls="cart-drawer"]', document).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var f = S.lastFocus;
    if (f && typeof f.focus === 'function' && document.contains(f)) {
      try { f.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  /* ---------- Eventos ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var trig = t.closest('[data-testid="cart-drawer-trigger"], [data-scd-open], a[href="#stooner-cart"]');
    if (trig && !t.closest('[data-scd]')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      open();
      return;
    }

    var r = root();
    if (!r || !r.contains(t)) return;

    if (t.closest('[data-scd-close]')) { close(); return; }

    var row = t.closest('.scd-item');
    if (row) {
      var key = row.getAttribute('data-key');
      var qty = Number(row.getAttribute('data-qty')) || 1;
      if (t.closest('[data-scd-plus]')) { changeQty(key, qty + 1, row); return; }
      if (t.closest('[data-scd-minus]')) { changeQty(key, qty - 1, row); return; }
      if (t.closest('[data-scd-remove]')) { changeQty(key, 0, row); return; }
    }

    var arrow = t.closest('[data-scd-arrow]');
    if (arrow) { scrollUp(Number(arrow.getAttribute('data-scd-arrow'))); return; }

    var add = t.closest('[data-scd-up-add]');
    if (add) { handleUpAdd(add.closest('.scd-up__card'), add); return; }

    var pick = t.closest('[data-scd-pick]');
    if (pick) { addVariant(pick.getAttribute('data-vid'), pick); return; }

    if (t.closest('[data-scd-pick-close]')) closeSheets();
  }, true);

  document.addEventListener('keydown', function (e) {
    var r = root();
    if (!r || !r.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var panel = q('[data-scd-panel]');
    var f = qa('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', panel).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Detecta añadidos/cambios hechos por cualquier otro script de la tienda */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var p = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || String(input || '');
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var m = method === 'POST' ? /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.exec(url) : null;
      if (m && !S.internal && root()) {
        p.then(function (res) { if (res && res.ok) onExternalChange(m[1]); }, function () {});
      }
    } catch (err) {}
    return p;
  };

  function onExternalChange(kind) {
    clearTimeout(S.extT);
    S.extT = setTimeout(function () {
      D.refresh().then(function () {
        if (kind === 'add' && conf('auto-open') === 'true') openWhenFree();
      });
    }, 40);
  }

  /* Acción estándar de Shopify "abrir carrito" */
  function hookActions() {
    try {
      var a = window.Shopify && window.Shopify.actions;
      if (a && a.openCart && typeof a.openCart.configure === 'function') {
        a.openCart.configure({ handler: function () { open(); return Promise.resolve(); } });
      }
    } catch (e) {}
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) D.refresh(); });
  window.addEventListener('load', hookActions);

  /* Editor de temas */
  function isMine(e) { return e.target && e.target.querySelector && e.target.querySelector('[data-scd]'); }
  document.addEventListener('shopify:section:load', function (e) {
    if (!isMine(e)) return;
    bind();
    D.render();
    if (S.wasOpen || conf('preview') === 'true') { S.wasOpen = false; open(); }
  });
  document.addEventListener('shopify:section:select', function (e) { if (isMine(e)) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (isMine(e) && conf('preview') !== 'true') close(); });

  function init() {
    if (!root()) return;
    bind();
    hookActions();
    D.refresh().then(function () {
      if (conf('preview') === 'true' && conf('design') === 'true') open();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.StoonerCartDrawer = { open: open, close: close, refresh: D.refresh };
})();